import {
  PROJECT_ON_BOARD_INSTALL_ADDITIONAL_PLUGIN_BEGIN,
  PROJECT_ON_BOARD_INSTALL_ADDITIONAL_PLUGIN_SUCCESS,
  PROJECT_ON_BOARD_INSTALL_ADDITIONAL_PLUGIN_FAILURE,
  PROJECT_ON_BOARD_INSTALL_ADDITIONAL_PLUGIN_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import { toast } from 'react-toastify';
import { getErrorMessageFromResponse } from '../../../common/utils/errorUtils';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import { Mixpanel } from '../../../common/utils/mixpanelUtil';

export function installAdditionalPlugin(args = {}) {
  return (dispatch) => {
    dispatch({
      type: PROJECT_ON_BOARD_INSTALL_ADDITIONAL_PLUGIN_BEGIN,
    });
    const { projectId, version } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.post(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/project-on-board/install-additional-plugin`,
        args.pluginsFormData,
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: PROJECT_ON_BOARD_INSTALL_ADDITIONAL_PLUGIN_SUCCESS,
            data: res,
          });
          Mixpanel.track('Installed Additional Plugin Successfully on project onboard');
          resolve(res);
        },
        (err) => {
          dispatch({
            type: PROJECT_ON_BOARD_INSTALL_ADDITIONAL_PLUGIN_FAILURE,
            data: { error: err },
          });
          Mixpanel.track('Failed to install Additional Plugin Successfully on project onboard');
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissInstallAdditionalPluginError() {
  return {
    type: PROJECT_ON_BOARD_INSTALL_ADDITIONAL_PLUGIN_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case PROJECT_ON_BOARD_INSTALL_ADDITIONAL_PLUGIN_BEGIN:
      return {
        ...state,
        installAdditionalPluginPending: true,
        installAdditionalPluginError: null,
      };

    case PROJECT_ON_BOARD_INSTALL_ADDITIONAL_PLUGIN_SUCCESS:
      return {
        ...state,
        installAdditionalPluginPending: false,
        installAdditionalPluginError: null,
      };

    case PROJECT_ON_BOARD_INSTALL_ADDITIONAL_PLUGIN_FAILURE:
      return {
        ...state,
        installAdditionalPluginPending: false,
        installAdditionalPluginError: action.data.error,
      };

    case PROJECT_ON_BOARD_INSTALL_ADDITIONAL_PLUGIN_DISMISS_ERROR:
      return {
        ...state,
        installAdditionalPluginError: null,
      };

    default:
      return state;
  }
}
